import { storyblokEditable } from "gatsby-source-storyblok"

import ProductBorderedHero from "@components/V2/Heroes/Product/BorderedHero"
import {
  getCmsOnlyItemFields,
  isConsolidatedPurchasableItem,
  parseConsolidatedPrice,
  useGetConsolidatedItem,
} from "@hooks/V2/storyblok/useConsolidatedItem"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokProductBorderedHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductBorderedHero>) => {
  const getConsolidatedItem = useGetConsolidatedItem()

  const resolvedItem = getConsolidatedItem(blok?.productConfig)
  const consolidatedItem = isConsolidatedPurchasableItem(resolvedItem)
    ? resolvedItem
    : undefined

  const itemFields =
    consolidatedItem ?? getCmsOnlyItemFields(blok?.productConfig)

  const getPrimaryCTALink = () => {
    return storyblokLinkToYocoLink(blok.primaryCTALink) ?? itemFields.ctaLink
  }

  const getPrimaryCTAText = () => {
    if (blok.primaryCTAText && blok.primaryCTAText.trim() !== "") {
      return blok.primaryCTAText
    }
    if (itemFields.ctaText && itemFields.ctaText.trim() !== "") {
      return itemFields.ctaText
    }
    return ""
  }

  const productDescription =
    blok.descriptionOverride && blok.descriptionOverride.trim() !== ""
      ? blok.descriptionOverride
      : (consolidatedItem?.shortDescription ?? "")

  return (
    <ProductBorderedHero
      secondaryButtonLink={storyblokLinkToYocoLink(blok.secondaryCTALink) ?? ""}
      secondaryButtonText={blok.secondaryCTAText}
      videoUrl={blok.video?.filename ?? ""}
      backgroundColor={blok.backgroundColor}
      cardColor={blok.cardColor}
      backgroundImageUrl={blok.backgroundImage?.filename ?? ""}
      backgroundImageAlt={blok.backgroundImage?.alt ?? ""}
      mobileImageUrl={blok.mobileImage?.filename}
      mobileImageAlt={blok.mobileImage?.alt}
      coverImageUrl={blok.coverImage?.filename ?? ""}
      coverImageAlt={blok.coverImage?.alt ?? ""}
      paymentStrips={itemFields}
      badgeText={blok.productConfig.content.badges?.[0]?.text}
      badgeAccentColor={blok.productConfig.content.badges?.[0]?.color}
      productName={itemFields.name}
      productDescription={productDescription}
      priceValue={parseConsolidatedPrice(consolidatedItem?.price)}
      priceSideScriptText={
        consolidatedItem?.onPromotion
          ? `R${parseConsolidatedPrice(consolidatedItem.originalPrice)}`
          : undefined
      }
      priceAdornmentText="R"
      priceSubscriptText={itemFields.priceSubScript}
      priceSuperscriptText={blok.priceSuperscriptText}
      hideMobileStickyButton={blok.hideMobileStickyButton}
      primaryButtonText={getPrimaryCTAText()}
      primaryButtonLink={getPrimaryCTALink()}
      textColor={blok.textColor}
      lightPaymentStripOverride={blok.lightPaymentStripOverride}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokProductBorderedHero
